import { Slot } from '@radix-ui/react-slot'
import { cn } from '../utils'
import { useFormField } from './field'
import { useGetError } from './useGetError'

function GenericSlot<P = React.HTMLAttributes<HTMLElement>>(
  props: React.ComponentPropsWithoutRef<typeof Slot> & P,
) {
  return <Slot {...props} />
}

export const FieldControl = (props: React.ComponentPropsWithoutRef<typeof Slot>) => {
  const { id, path } = useFormField()
  const error = useGetError(path)

  const formDescriptionId = `${id}-form-item-description`
  const formMessageId = `${id}-form-item-message`

  return (
    <GenericSlot
      id={id}
      aria-describedby={!error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`}
      aria-invalid={!!error}
      name={path}
      className={cn(!!error && 'border-red-500')}
      {...props}
    />
  )
}
